<div class="dmi-status-indicator-container">
    @if (!isDmiStatusLoading) {
        <span class="dmi-status-indicator" [ngClass]="dmiStatusClass" [matTooltip]="dmiStatus?.statusDescription ?? ''"></span>
    }
    @if (isDmiStatusLoading) {
        <mat-spinner [diameter]="16" class="dmi-status-indicator-loading" />
    }
</div>
